import React from 'react';
import styled from '@emotion/styled';

const Input = styled.input`
  position: absolute;
  left: -999em;
`;

export default props => <Input type="file" {...props} />;
